import React from "react";

export default function BannerHeader() {
  return (
    <section
      data-testid="banner-header"
      className="w-full bg-black overflow-hidden border-b-4 border-halo-red"
    >
      <div className="max-w-[1600px] mx-auto">
        <img
          src="https://customer-assets-wrfwihn1.emergentagent.net/job_halo-infield/artifacts/b4w1ynbn_ChatGPT%20Image%20Jul%2016%2C%202026%2C%2010_08_43%20PM.png"
          alt="HITI Network — Covering the Angels, Ducks & NFL"
          className="w-full h-auto block"
          loading="eager"
        />
      </div>
    </section>
  );
}
